(function () {
  const WRAPPER_SELECTOR = '.header-wrapper.rocket-header';
  const THEME_CLASSES = ['header-wrapper--theme-light', 'header-wrapper--theme-dark'];

  function applyTheme(theme) {
    const wrapper = document.querySelector(WRAPPER_SELECTOR);
    if (!wrapper || (theme !== 'light' && theme !== 'dark')) return;
    THEME_CLASSES.forEach((c) => wrapper.classList.remove(c));
    wrapper.classList.add('header-wrapper--theme-' + theme);
    document.documentElement.setAttribute('data-header-theme', theme);
  }

  function measureLayout() {
    const root = document.documentElement;
    const group = document.querySelector('.shopify-section-group-header-group');
    const headerSection = group?.querySelector('.section-header');
    const announcementSection =
      headerSection?.previousElementSibling?.classList?.contains('shopify-section')
        ? headerSection.previousElementSibling
        : null;

    root.style.setProperty(
      '--rocket-announcement-bar-height',
      announcementSection ? announcementSection.offsetHeight + 'px' : '0px'
    );

    if (headerSection) {
      root.style.setProperty('--rocket-header-overlay-height', headerSection.offsetHeight + 'px');
    }
  }

  function getFirstMainSection() {
    const main = document.getElementById('MainContent');
    if (!main) return null;
    return main.querySelector(':scope > .shopify-section, :scope > shopify-section');
  }

  function getSectionHeaderTheme(section) {
    const theme = section?.dataset?.headerTheme;
    return theme === 'dark' || theme === 'light' ? theme : null;
  }

  function initHome() {
    document.documentElement.classList.add('rocket-header-overlay-home');
    measureLayout();
    window.addEventListener('resize', measureLayout, { passive: true });

    const firstSection = getFirstMainSection();
    const heroTheme = getSectionHeaderTheme(firstSection) || 'dark';
    applyTheme(heroTheme);

    if (!firstSection) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;
        if (entry.isIntersecting && entry.intersectionRatio > 0.12) {
          applyTheme(getSectionHeaderTheme(firstSection) || 'dark');
        } else {
          applyTheme('light');
        }
      },
      { threshold: [0, 0.12, 0.35], rootMargin: '-40px 0px 0px 0px' }
    );

    observer.observe(firstSection);
  }

  function initDefault() {
    const wrapper = document.querySelector(WRAPPER_SELECTOR);
    const theme = wrapper?.dataset?.defaultTheme === 'dark' ? 'dark' : 'light';
    applyTheme(theme);
    measureLayout();
    window.addEventListener('resize', measureLayout, { passive: true });
  }

  function init() {
    if (document.body.classList.contains('template-index')) {
      initHome();
    } else {
      initDefault();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
